module.exports = __webpack_public_path__ + "img/aParty_110923_H.1a882e06.jpg";